(function() {
  'use strict';

  angular
    .module('admin.users.details.blockchain_address.service', [])
    .factory('BlockchainAddressService', BlockchainAddressService);

  /** @ngInject */
  function BlockchainAddressService($http, $q, API) {
    function list(userId) {
      var defer = $q.defer();

      $http
        .get(API.API_URL + "admin/users/" + userId + "/blockchain_addresses")
        .success(defer.resolve)
        .error(defer.reject);

      return defer.promise;
    }

    return{
      list: list
    };

  }

})();
